var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-container"},[_c('img',{attrs:{"src":require("@/assets/images/no-data.svg"),"alt":""}}),_c('h6',{staticClass:"text-center mb-3"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }